
<div class="container text-center">
    <br>
    <div class="form-group">
        <img width="40%" src="/assets/img/sofipa.png">
    </div>
    <div class="">
      <h2><strong>¡Bienvenid@ {{nombre}}!</strong></h2>
        <h2>Sistema de gestión de usuarios y recursos de T.I.</h2>
    </div>
  </div>
